import { useTranslation } from "react-i18next";
import LoadingSpinner from "@/components/atomic/Loading";
import { useTags } from "@/hooks/useTags";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { cn } from "@/lib/utils";

interface VocSearchTagFilterProps {
  tagIds: string[];
  onToggleTagId: (tagId: string) => void;
}

export const VocSearchTagFilter: React.FC<VocSearchTagFilterProps> = ({ tagIds, onToggleTagId }) => {
  const { t } = useTranslation("voiceek_ui");
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { tags, isLoading } = useTags(sessionCurrentWorkspaceId || "");

  if (!tags?.length && !isLoading) {
    return null;
  }

  return (
    <div className="flex gap-6 min-h-9">
      <div className="flex items-start pt-[10px] w-[60px]">
        <p className="text-[14px] font-semibold text-[#333333]">
          {t("vocFilter.tags")}
        </p>
      </div>

      <div className="flex items-stretch self-stretch">
        <div className="w-[2px] bg-[#d9d9d9]" />
      </div>

      <div className="basis-0 grow flex flex-col items-start justify-center min-h-px min-w-px">
        {isLoading
          ? <LoadingSpinner />
          : (
            <div className="content-start flex flex-wrap gap-[16px] items-start w-full">
              {tags?.map((tag) => (
                <button
                  key={tag.id}
                  onClick={() => onToggleTagId(tag.id)}
                  className={cn(
                    "border px-[16px] py-[6px] rounded-[13px] text-[14px] leading-[12px] text-center transition-colors hover:cursor-pointer",
                    tagIds.includes(tag.id)
                      ? "bg-[#6888e1] text-white border-[#6888e1]"
                      : "border-[#5f6368] text-[#333]",
                  )}
                >
                  {tag.name}
                </button>
              ))}
            </div>
          )}
      </div>
    </div>
  );
};
